var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearfix list-box-f"},[_c('div',{staticClass:"text"},[_vm._t("name")],2),_c('div',{staticClass:"cont"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }